import BMap from 'BMap'
import bus from '../bus/bus'
import i18n from '../i18n/i18n'
class MapInitControl extends BMap.Control {
  constructor (option) {
    super()
    // 默认停靠位置和偏移量
    // 也可以由传入的参数控制
    this.defaultAnchor = option.anchor || BMAP_ANCHOR_TOP_LEFT
    this.defaultOffset = option.offset || new BMap.Size(20, 20)
    this.node = null
    // 自定义参数
    // .....
  }
  setText(){
      this.node.innerHTML = i18n.t('home.globalView')
  }
  initialize (map) {
    // 这个初始化方法需要传入map，但事实上使用时没有手动调用initialize方法，也就没有传入map地图实例
    // 在添加这个控件实例到地图上时，自动调用初始化方法，然后传入了当前的地图实例
    // 使用一个自己不需要手动传入的参数还是感觉有那么一点怪异
    // console.log(map)
    const div = document.createElement('div')
    // 添加文字说明
    let   globalViewText = document.createTextNode(i18n.t('home.globalView'))
    this.node = div
    div.appendChild(globalViewText)
    // 设置样式
    div.style.cursor = "pointer"
    div.style.border = ".5px solid #aaa"
    div.style.fontSize = '12px'
    div.style.backgroundColor = 'rgba(139, 164, 220, .9)'
    div.style.color = 'rgb(255, 255, 255)'
    div.style.padding = '3px 6px'
    div.style.boxShadow = '2px 2px 3px rgba(0, 0, 0, 0.35)'
    // div.s
    // 监听点击事件
    div.addEventListener('click', () => {
      bus.$emit('setViewport')
    })
    // 添加DOM元素到地图中
    map.getContainer().appendChild(div)
    // 将DOM元素返回
    return div
  }
}

export default MapInitControl